import SkeletonTable from '~/core/molecules/SkeletonTable';

export const ChatSkeleton = () => {
  return (
    <>
      <SkeletonTable rowsCount={1} columnsCount={1} cellClassName="text-bluesky-700/5" />
      <SkeletonTable rowsCount={2} columnsCount={2} />
      <SkeletonTable rowsCount={1} columnsCount={2} cellClassName="text-bluesky-700/5" />
      <SkeletonTable rowsCount={1} columnsCount={2} />
    </>
  );
};
